/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defClientAutonomousNav: FuseNavigationItem[] = [
    {
        id   : 'cadastro',
        title: 'Cadastro',
        subtitle: 'Armazém, produtos, ...',
        type : 'group',
        icon : 'heroicons_outline:finger-print',
        children : [
            {
                id   : 'storage',
                title: 'Armazém',
                type : 'group',
                icon : 'glyphicons:forklift',
                children: [
                    {
                        id   : 'storages',
                        title: 'Cadastrar armazém',
                        type : 'basic',
                        icon : 'glyphicons:transport-trolley',
                        link : '/cadastro/storage'
                    },
                    {
                        id   : 'rules',
                        title: 'Regras de armazenagem',
                        type : 'basic',
                        icon : 'rule',
                        link : '/cadastro/rules'
                    }
                ]
            }
        ]
    },
    {
        id   : 'autonomous',
        title: 'Automação',
        subtitle: 'Solicitação de processos automatizados',
        type : 'group',
        icon : 'mat_outline:precision_manufacturing',
        children: [
            {
                id   : 'autonomous.autonomousProduction',
                title: 'Ordem de produção',
                subtitle: 'Ordem de produção de processo automatizado',
                type : 'basic',
                icon : 'mat_outline:precision_manufacturing',
                link : '/order-autonomous/autonomous-production'
            },
            {
                id   : 'autonomous.autonomousPicking',
                title: 'Ordem de picking',
                subtitle: 'Ordem de picking de processo automatizado',
                type : 'basic',
                icon : 'mat_solid:add_shopping_cart',
                link : '/order-autonomous/autonomous-picking'
            },
        ]
    },
    {
        id   : 'autonomous.operations',
        title: 'Operações automatizadas',
        type : 'group',
        icon : 'mat_outline:dvr',
        children : [
            {
                id   : 'autonomous.operationProd',
                title: 'Operação de produção',
                subtitle: 'Operações de produção executadas',
                type : 'basic',
                icon : 'mat_outline:precision_manufacturing',
                link : '/operation-autonomous/autonomous-production'
            },
            {
                id   : 'autonomous.operationOrder',
                title: 'Operação de armazenamento',
                subtitle: 'Operações de armazenamento executadas',
                type : 'basic',
                icon : 'mat_outline:archive',
                link : '/operation-autonomous/autonomous-order'
            },
            {
                id   : 'autonomous.operationPicking',
                title: 'Operação de picking',
                subtitle: 'Operações de picking executadas',
                type : 'basic',
                icon : 'mat_outline:add_shopping_cart',
                link : '/operation-autonomous/autonomous-picking'
            },
            {
                id   : 'autonomous.devolution',
                title: 'Operação de devolução',
                subtitle: 'Ordens de devolução',
                type : 'basic',
                icon : 'glyphicons:palette-package',
                link : '/operation-autonomous/autonomous-devolution'
            },
            {
                id   : 'autonomous.branchTransfer',
                title: 'Transferência',
                subtitle: 'Transferência entre filiais.',
                type : 'basic',
                icon : 'glyphicons:transport-trolley',
                link : '/operation-autonomous/autonomous-branch-transfer'
            }
        ]
    },
    {
        id   : 'inventory',
        title: 'Inventário',
        subtitle: 'Gerenciamento de inventário',
        type : 'group',
        icon : 'mat_outline:inventory_2',
        children: [
            {
                id   : 'inventory.manager',
                title: 'Solicitação',
                subtitle: 'Solicitação de inventário',
                type : 'basic',
                icon : 'mat_outline:inventory',
                link : '/autonomous-inventory'
            },
            {
                id   : 'inventory.manager',
                title: 'Final de lote',
                subtitle: 'Validação de final de lote',
                type : 'basic',
                icon : 'mat_outline:inventory',
                link : '/autonomous-inventory/final-lote'
            }
        ]
    },
    {
        id   : 'reports',
        title: 'Estatísticas',
        subtitle: 'Métricas e relatórios',
        type : 'group',
        icon : 'mat_outline:summarize',
        children: [
            {
                id   : 'report.list',
                title: 'Relátorios',
                subtitle: 'Lista de todas as operações',
                type : 'basic',
                icon : 'mat_outline:summarize',
                link : '/dashboard-autonomous'
            }
        ]
    }
];

export const defClientAutonomousNavUs: FuseNavigationItem[] = [
    {
        id   : 'cadastro',
        title: 'Register',
        subtitle: 'Warehouse, rules',
        type : 'group',
        icon : 'heroicons_outline:finger-print',
        children : [
            {
                id   : 'storage',
                title: 'Warehouse',
                type : 'group',
                icon : 'glyphicons:forklift',
                children: [
                    {
                        id   : 'storages',
                        title: 'Register warehouse',
                        type : 'basic',
                        icon : 'glyphicons:transport-trolley',
                        link : '/cadastro/storage'
                    },
                    {
                        id   : 'rules',
                        title: 'Storage rules',
                        type : 'basic',
                        icon : 'rule',
                        link : '/cadastro/rules'
                    }
                ]
            }
        ]
    },
    {
        id   : 'autonomous',
        title: 'Automation',
        subtitle: 'Automated process requests',
        type : 'group',
        icon : 'mat_outline:precision_manufacturing',
        children: [
            {
                id   : 'autonomous.autonomousProduction',
                title: 'Production Order',
                subtitle: 'Automated process for production order',
                type : 'basic',
                icon : 'mat_outline:precision_manufacturing',
                link : '/order-autonomous/autonomous-production'
            },
            {
                id   : 'autonomous.autonomousPicking',
                title: 'Picking Order',
                subtitle: 'Automated process for picking order',
                type : 'basic',
                icon : 'mat_solid:add_shopping_cart',
                link : '/order-autonomous/autonomous-picking'
            },
        ]
    },
    {
        id   : 'autonomous.operations',
        title: 'Automated operations',
        type : 'group',
        icon : 'mat_outline:dvr',
        children : [
            {
                id   : 'autonomous.operationProd',
                title: 'production operations',
                subtitle: 'Production operations performed',
                type : 'basic',
                icon : 'mat_outline:precision_manufacturing',
                link : '/operation-autonomous/autonomous-production'
            },
            {
                id   : 'autonomous.operationOrder',
                title: 'Storage operation',
                subtitle: 'Storage operations performed',
                type : 'basic',
                icon : 'mat_outline:archive',
                link : '/operation-autonomous/autonomous-order'
            },
            {
                id   : 'autonomous.operationPicking',
                title: 'Picking operation',
                subtitle: 'Picking operations performed',
                type : 'basic',
                icon : 'mat_outline:add_shopping_cart',
                link : '/operation-autonomous/autonomous-picking'
            },
            {
                id   : 'autonomous.devolution',
                title: 'Devolution operation',
                subtitle: 'Devolution orders',
                type : 'basic',
                icon : 'glyphicons:palette-package',
                link : '/operation-autonomous/autonomous-devolution'
            },
            {
                id   : 'autonomous.branchTransfer',
                title: 'Transfer',
                subtitle: 'Branch transfer',
                type : 'basic',
                icon : 'glyphicons:transport-trolley',
                link : '/operation-autonomous/autonomous-branch-transfer'
            }
        ]
    },
    {
        id   : 'inventory',
        title: 'Inventory',
        subtitle: 'Inventory Management',
        type : 'group',
        icon : 'mat_outline:inventory_2',
        children: [
            {
                id   : 'inventory.manager',
                title: 'Requests',
                subtitle: 'Inventory Request',
                type : 'basic',
                icon : 'mat_outline:inventory',
                link : '/autonomous-inventory'
            }
        ]
    },
    {
        id   : 'reports',
        title: 'Statistics',
        subtitle: 'Metrics and reports',
        type : 'group',
        icon : 'mat_outline:summarize',
        children: [
            {
                id   : 'report.list',
                title: 'Reports',
                subtitle: 'List of operations',
                type : 'basic',
                icon : 'mat_outline:summarize',
                link : '/dashboard-autonomous'
            }
        ]
    }
];